const DEFAULT_RATINGS = [
  {
    strength: { id: "", name: "test", displayTitle: "", shortDefinition: "", factorName: "" },
    zScore: 50,
    shortDefinition: "xxx",
  },
];

function fontClass(index: number): string {
  let fontSizeClass = "mapping-strengths-xl";

  if (index >= 5) {
    fontSizeClass = "mapping-strengths-lg";
  }

  if (index >= 10) {
    fontSizeClass = "mapping-strengths-md";
  }

  if (index >= 20) {
    fontSizeClass = "mapping-strengths-sm";
  }

  if (index >= 29) {
    fontSizeClass = "mapping-strengths-xs";
  }
  return fontSizeClass;
}

export { DEFAULT_RATINGS, fontClass };
